var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 434.72 424.99",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-4{fill:none;}.cls-2{fill:#fff;}.cls-3{clip-path:url(#clip-path);}.cls-4{stroke:#fff;stroke-miterlimit:10;stroke-width:8px;}.cls-5{clip-path:url(#clip-path-2);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(0.13 -3.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 8.06,
    y: -7.56,
    width: 416.52,
    height: 161.08
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(0.13 -3.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 8.06,
    y: 278.48,
    width: 416.52,
    height: 161.08
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10.78,257.17H-.13V193.71H10.78v7.09a15.73,15.73,0,0,1,14.09-7.73q9,0,14.32,6.46t5.32,17q0,10.36-5.32,17.14a17.33,17.33,0,0,1-14.41,6.77q-9.27,0-14-7.54Zm3.45-51.28q-3.45,3.56-3.45,10.55t3.36,10.82a10.42,10.42,0,0,0,8.1,3.82,9.86,9.86,0,0,0,8-3.78q3.09-3.77,3.09-10.59t-3.09-10.59a9.67,9.67,0,0,0-7.82-3.77A11.08,11.08,0,0,0,14.23,205.89Z",
    transform: "translate(0.13 -3.5)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M67.24,179.89a6.4,6.4,0,0,1-1.9,4.72,6.59,6.59,0,0,1-9.28,0,6.41,6.41,0,0,1-1.91-4.72,6.55,6.55,0,1,1,13.09,0Zm-1.09,59.92H55.24v-46.1H66.15Z",
    transform: "translate(0.13 -3.5)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M87.16,239.81h-12l16.1-23.28L76.16,193.71H88.43l8.64,15,9.09-15h12.19l-16,22.91,15.46,23.19H105.71l-9.1-15.46Z",
    transform: "translate(0.13 -3.5)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M161.63,237.26q-4.83,3-13.91,3-11,0-17.37-6.54T124,216.8q0-11,6-17.27a19.91,19.91,0,0,1,15-6.28q9,0,14.27,5.46t5.28,15.91a44.08,44.08,0,0,1-.64,6.55H135a12.36,12.36,0,0,0,4.95,7.64,16.09,16.09,0,0,0,9.41,2.63,20.3,20.3,0,0,0,12.28-3.64ZM145.26,201.8a9.24,9.24,0,0,0-6.77,2.86c-1.91,1.91-3.14,4.69-3.69,8.32h19.37v-1.36a11.56,11.56,0,0,0-2.41-7.14A8,8,0,0,0,145.26,201.8Z",
    transform: "translate(0.13 -3.5)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M186.81,239.81H175.9V175.52h10.91Z",
    transform: "translate(0.13 -3.5)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M224,234.26q-3.18,5.91-12,5.91c-4.36,0-7.84-1.27-10.41-3.82a13,13,0,0,1-3.87-9.64,12.2,12.2,0,0,1,4.91-10.27q4.92-3.74,14.19-3.73h6.73v-2.82a7.92,7.92,0,0,0-2-5.82q-2-2-6.82-2a24.11,24.11,0,0,0-13.55,4.09V196.07q5.17-3.18,14.91-3.18,18.74,0,18.73,17.46v29.46H224Zm-8.18-2.18a7.47,7.47,0,0,0,5.68-2.14,7.72,7.72,0,0,0,2.05-5.59V220h-5.64q-4.28,0-6.55,1.77a5.48,5.48,0,0,0-2.27,4.5Q209.09,232.08,215.82,232.08Z",
    transform: "translate(0.13 -3.5)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M258.37,239.81H247.46V175.52h10.91Z",
    transform: "translate(0.13 -3.5)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M313.57,216.62q0,10.45-5.87,17.19t-16.41,6.73q-10.46,0-16.32-6.55t-5.87-16.73q0-10.55,6.09-17.41t16.1-6.87q10.63,0,16.46,6.68T313.57,216.62Zm-33,.27a18.91,18.91,0,0,0,2.82,10.64,9.76,9.76,0,0,0,16.09.09A19.07,19.07,0,0,0,302.2,217q0-6.65-2.64-10.87t-8.27-4.23a9,9,0,0,0-8,4.27A19.34,19.34,0,0,0,280.56,216.89Z",
    transform: "translate(0.13 -3.5)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M364.48,235.62q0,10.92-6.32,16.42t-16,5.5a36.44,36.44,0,0,1-15.92-3.27v-11.1A25,25,0,0,0,341,247.54q12.56,0,12.55-12v-4q-4.19,6.83-13.09,6.82a17.75,17.75,0,0,1-13.23-5.68q-5.5-5.68-5.5-16.5,0-10,5.23-16.51a16.8,16.8,0,0,1,13.77-6.5q8.64,0,12.82,7.19v-6.64h10.91Zm-31.37-19.45q0,6.45,2.82,9.86a8.91,8.91,0,0,0,7.19,3.41,9.41,9.41,0,0,0,7.45-3.5,13.55,13.55,0,0,0,3-9.14q0-7.37-2.91-10.82a9.21,9.21,0,0,0-7.36-3.45,8.79,8.79,0,0,0-7.46,3.68C334,208.67,333.11,212,333.11,216.17Z",
    transform: "translate(0.13 -3.5)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M389.12,179.89a6.4,6.4,0,0,1-1.9,4.72,6.59,6.59,0,0,1-9.28,0,6.41,6.41,0,0,1-1.91-4.72,6.55,6.55,0,1,1,13.09,0ZM388,239.81H377.12v-46.1H388Z",
    transform: "translate(0.13 -3.5)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M434.59,237.81a23.45,23.45,0,0,1-12,2.82q-10.65,0-17.23-6.73t-6.6-17a24.21,24.21,0,0,1,6.6-17q6.5-6.91,17.77-6.91a23.84,23.84,0,0,1,11.46,2.55v9.63a18.9,18.9,0,0,0-10.37-2.91,13.7,13.7,0,0,0-10.27,4q-3.92,4-4,10.63a15.42,15.42,0,0,0,3.95,10.55q3.78,4,10.23,4a19,19,0,0,0,10.46-3.09Z",
    transform: "translate(0.13 -3.5)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 217.52,
    cy: 212.26,
    r: 208.26
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 217.52,
    cy: 212.73,
    r: 208.26
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d1dc598885f44b2b8fd3bbdf0e5bcfe2.svg";
export { ForwardRef as ReactComponent };